<template>
  <div class="container is-max-desktop">
    <b-loading v-model="loading" />
    <div class="box fanform">
      <ValidationObserver ref="fanForm" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="columns">
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="name"
                :name="$t('fields.name')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.name')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="name"
                >
                  <b-input
                    v-model="fan.name"
                    id="name"
                    @keydown.native="isLetter($event)"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="vorname"
                :name="$t('fields.vorname')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.vorname')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="vorname"
                >
                  <b-input
                    id="vorname"
                    v-model="fan.vorname"
                    @keydown.native="isLetter($event)"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-2">
              <ValidationProvider
                rules=""
                vid="Titel"
                :name="$t('fields.titel')"
              >
                <b-field :label="$t('fields.titel')" label-for="titel">
                  <b-input v-model="fan.titel" id="titel"></b-input>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="strasse"
                :name="$t('fields.strasse')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.strasse')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="strasse"
                >
                  <b-input v-model="fan.strasse" id="strasse"></b-input>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-2">
              <ValidationProvider
                rules="required"
                vid="hausnr"
                :name="$t('fields.hausnr')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.hausnr')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="hausnr"
                >
                  <b-input v-model="fan.haus_nr" id="hausnr"></b-input>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column is-2">
              <ValidationProvider
                rules="required"
                vid="plz"
                :name="$t('fields.plz')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.plz')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="plz"
                >
                  <b-input v-model="fan.plz" id="plz"></b-input>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="ort"
                :name="$t('fields.ort')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.ort')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="ort"
                >
                  <b-input v-model="fan.ort" id="ort"></b-input>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="nation"
                :name="$t('fields.nation')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.nation')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="nation"
                >
                  <b-select
                    v-model="fan.nation"
                    id="nation"
                    expanded
                    :placeholder="$t('fields.placeholderSelect')"
                  >
                    <option
                      v-for="(item, index) of filteredNations"
                      :key="index"
                      :value="item.nation"
                    >
                      {{ item.land }}
                    </option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <ValidationProvider
                rules=""
                vid="herkunft"
                :name="$t('fields.herkunft')"
              >
                <b-field :label="$t('fields.herkunft')" label-for="herkunft">
                  <b-select
                    v-model="fan.herkunft"
                    id="herkunft"
                    expanded
                    :placeholder="$t('fields.placeholderSelect')"
                  >
                    <option
                      v-for="(item, index) of nations"
                      :key="index"
                      :value="item.nation"
                    >
                      {{ item.land }}
                    </option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            </div>

            <div class="column">
              <ValidationProvider
                rules="required"
                vid="sprache"
                :name="$t('fields.sprache')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.sprache')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="sprache"
                >
                  <b-select
                    v-model="fan.sprache"
                    id="sprache"
                    expanded
                    :placeholder="$t('fields.placeholderSelect')"
                  >
                    <option
                      v-for="(item, index) of languages"
                      :key="index"
                      :value="item.id_sprache"
                    >
                      {{ item.sprache }}
                    </option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="sex"
                :name="$t('fields.sex')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.sex')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="geschlecht"
                >
                  <b-select
                    v-model="fan.sex"
                    id="geschlecht"
                    expanded
                    :placeholder="$t('fields.placeholderSelect')"
                  >
                    <option
                      v-for="(item, index) of sex"
                      :key="index"
                      :value="item.id_sex"
                    >
                      {{ item.bezeichnung_lang }}
                    </option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <ValidationProvider
                rules=""
                vid="gebdatum"
                :name="$t('fields.gebDatum')"
              >
                <b-field :label="$t('fields.gebDatum')" label-for="gebdatum">
                  <b-datepicker
                    v-model="fan.geb_datum"
                    id="gebdatum"
                    :locale="$i18n.locale"
                    :focused-date="new Date('1970-01-01')"
                    :placeholder="$t('fields.placeholderDate')"
                    icon="calendar-today"
                    :icon-right="fan.geb_datum ? 'close-circle' : ''"
                    icon-right-clickable
                    @icon-right-click="clearDate"
                    :max-date="new Date()"
                    trap-focus
                  >
                  </b-datepicker>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column is-4">
              <ValidationProvider
                rules="required|between:1,100"
                vid="anzaufenthalte"
                :name="$t('fields.aufenthalte')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.aufenthalte')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="aufenthalte"
                >
                  <b-numberinput
                    v-model="fan.anz_aufenthalte"
                    id="aufenthalte"
                    max="100"
                    min="1"
                    aria-minus-label="Minus Button Aufenthalte"
                    aria-plus-label="Plus Button Aufenthalte"
                  ></b-numberinput>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <ValidationProvider
                rules="required|email"
                vid="email"
                :name="$t('fields.email')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.email')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="email"
                >
                  <b-input
                    v-model="fan.email"
                    type="email"
                    id="email"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </div>
            <div class="column">
              <ValidationProvider
                rules="required"
                vid="newsletter"
                :name="$t('fields.newsletter')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.newsletter')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="newsletter"
                >
                  <b-select
                    v-model="fan.newsletter"
                    id="newsletter"
                    expanded
                    :placeholder="$t('fields.placeholderSelect')"
                  >
                    <option value="0">{{ $t("values.nein") }}</option>
                    <option value="1">{{ $t("values.ja") }}</option>
                  </b-select>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <ValidationProvider
                rules=""
                vid="bemerkung"
                :name="$t('fields.bemerkung')"
              >
                <b-field :label="$t('fields.bemerkung')" label-for="bemerkung">
                  <b-input
                    v-model="fan.bemerkung"
                    type="textarea"
                    id="bemerkung"
                  ></b-input>
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column has-text-left">
              <ValidationProvider
                :rules="{ required: { allowFalse: false } }"
                vid="datenschutz"
                :name="$t('fields.datenschutz')"
                v-slot="{ errors, valid }"
              >
                <b-field
                  :label="$t('fields.datenschutz')"
                  :type="{ 'is-danger': errors[0], 'is-success': valid }"
                  :message="errors"
                  label-for="datenschutz"
                >
                  <b-checkbox v-model="fan.datenschutz" id="datenschutz"
                    ><a :href="$t('fields.datenschutzLink')" target="_blank">{{
                      $t("fields.datenschutzText")
                    }}</a></b-checkbox
                  >
                </b-field>
              </ValidationProvider>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-button
                type="is-danger is-light"
                aria-label="Submit Button"
                @click="handleSubmit(onSubmit)"
              >
                {{ String($t("fields.submitButton")).toUpperCase() }}</b-button
              >
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
import axios from "axios";

export default {
  name: "FanForm",
  components: { ValidationObserver, ValidationProvider },

  data: () => ({
    fan: {
      name: null,
      vorname: null,
      titel: "",
      strasse: null,
      nation: null,
      plz: null,
      ort: null,
      herkunft: null,
      sprache: null,
      sex: null,
      email: null,
      anz_aufenthalte: null,
      geb_datum: null,
      handy: "",
      newsletter: null,
      bemerkung: null,
      datenschutz: null,
    },

    selectedNation: null,
    nations: [],
    languages: [],
    sex: [],
    loading: false,
    apiURL:
      process.env.NODE_ENV === "production"
        ? "https://www.friendsofstanton.com/community-card/data.php"
        : "http://localhost/arlberg/data.php",
  }),

  async created() {
    if (this.$route.query.lang === "en") {
      this.$i18n.locale = "en";

      localize("en");
    } else {
      this.$i18n.locale = "de";
      localize("de");
    }
    document.documentElement.lang = this.$i18n.locale;

    this.loading = true;
    const nationsResult = await axios.get(
      `${this.apiURL}?q=nations&lang=${this.$root.$i18n.locale}`
    );
    const langResult = await axios.get(
      `${this.apiURL}?q=languages&lang=${this.$root.$i18n.locale}`
    );
    const sexResult = await axios.get(
      `${this.apiURL}?q=sex&lang=${this.$root.$i18n.locale}`
    );

    this.nations = nationsResult.data;
    this.languages = langResult.data;
    this.sex = sexResult.data;
    this.loading = false;
  },

  computed: {
    filteredNations() {
      return this.nations.filter((item) => item.nation !== "..");
    },
  },

  methods: {
    nationChanged() {
      if (!this.fan.herkunft) {
        this.fan.herkunft = this.fan.nation;
      }
    },

    clearDate() {
      this.fan.geb_datum = null;
    },

    isLetter(e) {
      const baseAllowedRegex = new RegExp(
        "Backspace|ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Tab|Delete"
      );
      if (e.metaKey) {
        // allow shortcuts like Ctrl/Command + A
        return true;
      }

      let lettersRegex;
      try {
        lettersRegex = new RegExp("\\p{L}", "u");
      } catch (e) {
        lettersRegex = new RegExp(`[a-z\u00C0-\u024F\u1E00-\u1EFF]`, "i");
      }

      let char = String.fromCharCode(e.keyCode || e.which); // Get the character
      if (lettersRegex.test(char) || baseAllowedRegex.test(e.key))
        return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    clearForm() {
      this.fan = {
        name: null,
        vorname: null,
        titel: "",
        strasse: null,
        nation: null,
        plz: null,
        ort: null,
        herkunft: null,
        sprache: null,
        sex: null,
        email: null,
        anz_aufenthalte: null,
        geb_datum: null,
        handy: "",
        newsletter: null,
        bemerkung: null,
        datenschutz: null,
      };
    },

    async onSubmit() {
      const result = await axios.post(`${this.apiURL}`, this.fan);
      if (result.data.success) {
        this.clearForm();
        this.$nextTick(() => this.$refs.fanForm.reset());

        this.$buefy.dialog.alert({
          title: this.$t("messages.titelDanke"),
          message: this.$t("messages.dialogTextSuccess"),
          confirmText: this.$t("messages.confirmText"),
        });
      } else {
        this.$refs.fanForm.setErrors(result.data.errors);
        this.$buefy.dialog.alert({
          title: this.$t("messages.titelFehler"),
          message: this.$t("messages.dialogTextFailure"),
          type: "is-danger",
          hasIcon: true,
          icon: "exclamation",
          iconPack: "mdi",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      }
    },
  },
};
</script>
<style>
.label {
  text-align: left;
  /*color: white;*/
}
.field .help {
  text-align: left;
  font-size: 1rem;
}
.fanform {
  /*background-color: #d52817 !important;*/
}
</style>
